class AnalyticsController {
  constructor(AnalyticsService, $q) {
    "ngInject"

    this.analyticsService = AnalyticsService;
    this.$q = $q;
  }

  $onInit() {
    this.isLoading = true;

    const getBotStatsPromise = this.analyticsService.getBotStatsData();

    this.$q.all([getBotStatsPromise]).then(data => {

      const [getBotStatsResponse] = data;
      
      this.setBotStatsOptions(getBotStatsResponse);

      this.isLoading = false;
    })
  
  }

  setBotStatsOptions(data) {
    var eventStats = data.series[0];
    var titleFormat = kendo.format("{0} - Events: {1}", eventStats.name, eventStats.totalCount);
    var labelFormat = "#= category # - #= kendo.format('{0:p0}', value) # \n #=kendo.format('{0:n0} Events', dataItem.value)#";
    this.botEventsOptions = this.analyticsService.getDonutChartOptions(eventStats, titleFormat, labelFormat);        
  }  
}

export default AnalyticsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/analytics-bot/analytics-bot.controller.js
 **/